import {
  FETCH_DEPARTMENTS_REQUEST,
  FETCH_DEPARTMENTS_SUCCESS,
  FETCH_DEPARTMENTS_FAILURE,
  FETCH_DEPARTMENT_REQUEST,
  FETCH_DEPARTMENT_SUCCESS,
  FETCH_DEPARTMENT_FAILURE,
  UPDATE_DEPARTMENTS_REQUEST,
  UPDATE_DEPARTMENTS_FAILURE,
  UPDATE_DEPARTMENTS_SUCCESS,
  DELETE_DEPARTMENTS_REQUEST,
  DELETE_DEPARTMENTS_FAILURE,
  DELETE_DEPARTMENTS_SUCCESS,
  FETCH_DEPARTMENTS_RELEASE_REQUEST,
  FETCH_DEPARTMENTS_RELEASE_SUCCESS,
  FETCH_DEPARTMENTS_RELEASE_FAILURE,
  CLEAR_DEPARTMENT_ERRORS,    // Nouvelles imports
  CLEAR_DEPARTMENT_SUCCESS,
} from './actionTypes';

const initialState = {
  departments: [],
  departmentsRelease: [], // Ajouté car utilisé dans le reducer
  department: null,
  loadingDepartment: false,
  errorDepartment: null,
  departmentAdded: null
};

const Departments = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEPARTMENTS_REQUEST:
      return {
        ...state,
        loadingDepartment: true,
        errorDepartment: null,
        departmentAdded: false
      };
    case FETCH_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        loadingDepartment: false,
        departments: action.payload.data,
      };
    case FETCH_DEPARTMENTS_FAILURE:
      return {
        ...state,
        loadingDepartment: false,
        errorDepartment: action.payload,
      };
    case FETCH_DEPARTMENTS_RELEASE_REQUEST:
      return {
        ...state,
        loadingDepartment: true,
        errorDepartment: null,
        departmentAdded: false
      };
    case FETCH_DEPARTMENTS_RELEASE_SUCCESS:
      return {
        ...state,
        loadingDepartment: false,
        departmentsRelease: action.payload.data,
      };
    case FETCH_DEPARTMENTS_RELEASE_FAILURE:
      return {
        ...state,
        loadingDepartment: false,
        errorDepartment: action.payload,
      };
    case FETCH_DEPARTMENT_REQUEST:
      return {
        ...state,
        loadingDepartment: true,
        errorDepartment: null,
        departmentAdded: false
      };
    case FETCH_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loadingDepartment: false,
        department: action.payload.data,
      };
    case FETCH_DEPARTMENT_FAILURE:
      return {
        ...state,
        loadingDepartment: false,
        errorDepartment: action.payload,
      };
    case UPDATE_DEPARTMENTS_REQUEST:
      return {
        ...state,
        loadingDepartment: true,
        errorDepartment: null,
        departmentAdded: false
      };
    case UPDATE_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        loadingDepartment: false,
        department: null,
        departmentAdded: true
      };
    case UPDATE_DEPARTMENTS_FAILURE:
      return {
        ...state,
        loadingDepartment: false,
        errorDepartment: action.payload,
      };
    case DELETE_DEPARTMENTS_REQUEST:
      return {
        ...state,
        loadingDepartment: true,
        errorDepartment: null,
        departmentAdded: false
      };
    case DELETE_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        departmentAdded: true,
        loadingDepartment: false,
        departments: state.departments.filter(department => department.id !== action.payload),
      };
    case DELETE_DEPARTMENTS_FAILURE:
      return {
        ...state,
        loadingDepartment: false,
        errorDepartment: action.payload,
      };
    case CLEAR_DEPARTMENT_ERRORS:
      return {
        ...state,
        errorDepartment: null,
      };
    case CLEAR_DEPARTMENT_SUCCESS:
      return {
        ...state,
        departmentAdded: null,
      };
      
    default:
      return state;
  }
};

export default Departments;